module.exports = __webpack_public_path__ + "img/teafarm.5bc21b9f.png";